export const OktaConfig = {
  clientId: '0oa1q9ef6815RBO3X1d8',
  domain: 'https://rbi.okta.com',
  issuer: 'https://rbi.okta.com/oauth2/default',
  redirectUri: window.location.origin + '/callback',
  postLogoutRedirectUri: window.location.origin + '/login',
  scopes: ['openid', 'profile', 'email'],
  pkce: true,
  grantType: ['implicit', 'authorization_code', 'refresh_token'],
};
